<template>
    <li
        class="relative text-gray-700 dark:text-gray-300 group flex items-center px-4 pl-8 py-2 text-sm group hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-900 dark:hover:text-gray-200 cursor-pointer"
        role="menuitem"
        tabindex="-1"
        id="menu-item-0"
    >
        <span class="font-normal block truncate">{{ item }}</span>
        <span
            v-if="selected"
            class="text-indigo-600 absolute inset-y-0 left-0 flex items-center pl-1.5"
        >
            <CheckIcon class="h-5 w-5" />
        </span>
        <span
            @click.stop="$emit('settings')"
            v-if="settings"
            class="opacity-0 group-hover:opacity-100 flex text-gray-300 hover:text-gray-500 absolute inset-y-0 right-0 items-center pr-1.5"
        >
            <TrashBinIcon class="h-5 w-5" />
        </span>
    </li>
</template>

<script>
import { CheckIcon, TrashBinIcon } from "@easy/ui/icons";
export default {
    name: "cOptionSelect",
    props: {
        item: String,
        selected: Boolean,
        settings: Boolean,
    },
    components: { CheckIcon, TrashBinIcon },
};
</script>
